__turbopack_context__.v({
  "content": "sport-bets-history-module-sass-module__R1AA_G__content",
});
